import {SelectInputElement} from '@/Agent/PreQualification/Components/SelectInputElement';
import {FormType} from '@/Agent/PreQualification/types';
import {Parameter} from '@/Core/mobx/ParameterStore/Parameter';
import {ParameterStore} from '@/Core/mobx/ParameterStore/ParameterStore';
import {quoteGuards} from '@/Core/mobx/ParameterStore/QuoteGuards';
import {fieldOptions} from '@/Core/mobx/ParameterStore/QuoteXref';
import {CategoryHeader, SwitchCustom} from '@/Core/UI';
import {Box, Card, Checkbox, FormControlLabel, FormHelperText, Grid, makeStyles} from '@material-ui/core';
import {observer} from 'mobx-react-lite';

export interface ADBTabProps {
    valueChanged: (p: Parameter, value: any, formType?: FormType) => void;
    parameterStore: ParameterStore;
    formType: FormType;
}

const ADBTab = observer(({valueChanged, parameterStore, formType}: ADBTabProps) => {
    const {quote, prequal} = parameterStore || {};

    const required = (
        <span>
            <span style={{color: 'red'}}>*</span>
        </span>
    );

    const WarningMessage = ({message}: {message: string}) => {
        const useStyles = makeStyles(() => ({
            warningBox: {
                marginTop: '3px',
                display: 'flex',
            },
            warningBoxTable: {
                marginTop: 0,
                marginLeft: '10px',
            },
            warningIcon: {
                display: 'flex',
                alignItems: 'center',
                marginRight: '10px',
            },
        }));
        const classes = useStyles();
        return (
            <Box className={classes.warningBox}>
                <FormHelperText error>{message}</FormHelperText>
            </Box>
        );
    };

    const handleProductChange = (p: Parameter, value: string) => {
        valueChanged(p, value);
        if (value === 'MOOGuaranteedADvantage') {
            if (
                prequal?.age.value >= 18 &&
                prequal?.age.value <= 50 &&
                !['AR', 'CT', 'GA', 'NY', 'PA', 'VA'].includes(prequal?.state.value)
            ) {
                valueChanged(quote.returnOnPremiumADB, true);
            } else {
                valueChanged(quote.returnOnPremiumADB, false);
            }
        }
    };

    return (
        <>
            <Card
                style={{
                    padding: 20,
                    marginBottom: 10,
                    borderBottomLeftRadius: 0,
                    borderBottomRightRadius: 0,
                }}
            >
                <Grid
                    item
                    style={{
                        marginBottom: 20,
                    }}
                    xs={12}
                >
                    <CategoryHeader name="Carrier Product" number={1} />
                </Grid>
                <Grid container spacing={3}>
                    <Grid item xs={6}>
                        <SelectInputElement
                            param={{
                                label: 'Product',
                                name: 'productADB',
                                options: fieldOptions.productADB.options,
                                optionValues: fieldOptions.productADB.optionValues,
                                ...quote.productADB,
                            }}
                            required={''}
                            valueChanged={(p: Parameter, value: string) => handleProductChange(p, value)}
                            formType={formType}
                        />
                        {quoteGuards.invalidStatesADB(parameterStore, quote) && (
                            <WarningMessage message="Warning: Product not available in MA, MN, or NM" />
                        )}
                    </Grid>
                </Grid>
                <Grid item style={{marginTop: 20, marginBottom: 20}} xs={12}>
                    <CategoryHeader name="Coverage and Premium" number={2} />
                </Grid>
                <Grid container spacing={3}>
                    <Grid item xs={6}>
                        <SelectInputElement
                            param={{
                                label: 'Plan Type',
                                name: 'planTypeADB',
                                options: fieldOptions.planTypeADB.options,
                                optionValues: fieldOptions.planTypeADB.optionValues,
                                ...quote.planTypeADB,
                            }}
                            required={''}
                            valueChanged={valueChanged}
                            formType={formType}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <SelectInputElement
                            param={{
                                label: 'Specified Coverage Amount',
                                name: 'specifiedCoverageADB',
                                options: fieldOptions.specifiedCoverageADB.options,
                                optionValues: fieldOptions.specifiedCoverageADB.optionValues,
                                ...quote.specifiedCoverageADB,
                            }}
                            required={''}
                            valueChanged={valueChanged}
                            formType={formType}
                        />
                    </Grid>
                </Grid>
                <Grid container spacing={3}>
                    {quote.planTypeADB.value === '_2Adults' && (
                        <Grid item xs={6}>
                            <SelectInputElement
                                param={{
                                    label: 'Second Covered Adult Age',
                                    name: 'secondCoveredAdultAgeADB',
                                    options: fieldOptions.secondCoveredAdultAgeADB.options,
                                    optionValues: fieldOptions.secondCoveredAdultAgeADB.optionValues,
                                    ...quote.secondCoveredAdultAgeADB,
                                }}
                                required={''}
                                valueChanged={valueChanged}
                                formType={formType}
                            />
                        </Grid>
                    )}
                    <Grid item xs={6}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                        valueChanged(quote.includeChildrenADB, e.target.checked);
                                    }}
                                    checked={quote.includeChildrenADB?.value}
                                    name="includeChildrenADB"
                                    color="secondary"
                                />
                            }
                            label="Include children"
                        />
                    </Grid>
                </Grid>
                <Grid item style={{marginTop: 20, marginBottom: 20}} xs={12}>
                    <CategoryHeader name="Policy Rider" number={3} />
                </Grid>
                <Grid item xs={4}>
                    <SwitchCustom
                        param={{
                            name: 'returnOnPremiumADB',
                            label: 'Return on Premium',
                            ...quote.returnOnPremiumADB,
                        }}
                        required={required}
                        valueChanged={valueChanged}
                    />
                    {quoteGuards.invalidReturnOnPremiumADB(parameterStore, quote) && (
                        <WarningMessage message="ROP Rider only available to adults age 18-50 and not living in AR, CT, GA, NY, PA, or VA" />
                    )}
                </Grid>
            </Card>
        </>
    );
});

export default ADBTab;
